/*
point : {
    "id":,
    "x":,
    "y":,
    "radius":
}
*/
/*
Ladmarks = {
    frequency: Number,
    Landmarks:[     // Frames
        [           // Persons
            [       // keypoints array
                point
            ]
        ]
    ]

}
*/
import { pld_radius, facelandmarks_include_map, globallandmarks_include_map, handlandmarks_include_map } from "./LandmarksConfigs"

// draw landmarks in canvas
export const drawLandmarks=(ctx,landmarksArray,canvasWidth,canvasHeight,flag_video)=>{
    landmarksArray.forEach((person,p_index)=>{
        if(p_index<2){
            person.forEach((landmark,f_index)=>{
                if(landmark.visibility){
                    //if(landmark.visibility > 0.5){
                        //if(facelandmarks_include_map[landmark.name]?.include || !landmark.name) {
                            ctx.beginPath()
                            ctx.fillStyle = 'white'
                            let x_point = landmark.x * canvasWidth
                            if (flag_video){
                                x_point = x_point + canvasWidth
                            }
                            let y_point = landmark.y * canvasHeight
                            ctx.arc(x_point,y_point,canvasHeight/310,0,2*Math.PI,true)
                            ctx.stroke()
                            ctx.fill()
                    //}
                }
                else{
                    ctx.beginPath()
                    ctx.fillStyle = 'white'
                    let x_point = landmark.x * canvasWidth
                    let y_point = landmark.y * canvasHeight
                    ctx.arc(x_point,y_point,0.7,0,2*Math.PI,true)
                    ctx.stroke()
                    ctx.fill()
                }
            })
        }
        
    })
    return ctx 
}

// draw movenetLandmarks in canvas
export const drawMovenetLandmarks=(ctx,keypoints)=>{
    keypoints.forEach((landmark)=>{
        ctx.clearRect(0,0,640,480)
        ctx.beginPath()
        ctx.fillStyle = 'white'
        let x_point = landmark.x
        let y_point = landmark.y
        ctx.arc(x_point,y_point,5,0,2*Math.PI,true)
        ctx.stroke()
        ctx.fill()
    })
    return ctx 
}

export const  getKeyByValue = (object, value)=>{
    for (let prop in object) {
        if (object[prop].hasOwnProperty('name')) {
            if (object[prop]['name'].toLowerCase() === value.toLowerCase()) {
                return prop;
            }
        }
    }
}

export const liveDrawMovenetLandmarks = (ctx,element,areNormalized,width,height,original_width,original_height,option,newL)=>{
    let landmarks_map = []
    let handedness = null
    let keypoints = element.keypoints
    switch (option) {
        case 'global_motor_skills':
            landmarks_map = globallandmarks_include_map;
            break;
        case 'fine_motor_skills':
            handedness = element.handedness
            landmarks_map = handlandmarks_include_map;
            break;
        case 'face_expression':
            landmarks_map = facelandmarks_include_map;
            break;
        default:
            landmarks_map = facelandmarks_include_map;
            break;
    }
    let point = {}
    let landmarkConfig_tmp = []
    keypoints.forEach((keypoint,f_index)=>{
        if(landmarks_map[f_index]?.include) {
            // ctx.beginPath()
            // ctx.fillStyle = 'white'
            // // point.x = (areNormalized) ? (-keypoint.x * width)+width: -(keypoint.x / original_width) * width +width
            // point.x = (areNormalized) ? keypoint.x * width: (keypoint.x / original_width) * width
            // point.y = (areNormalized) ? keypoint.y * height: (keypoint.y / original_height) * height
            // ctx.arc(point.x,point.y,2,0,2*Math.PI,true)
            // ctx.stroke()
            // ctx.fill()
            let nameID = []
            if (handedness){
                if (handedness=='Right') {
                    nameID = 'Left' + '_' + landmarks_map[f_index].name
                }
                if (handedness=='Left') {
                    nameID = 'Right' + '_' + landmarks_map[f_index].name
                }
            }
            else {
                nameID = landmarks_map[f_index].name
            }
            const id = getKeyByValue(newL, nameID)
            newL[id].name = nameID
            newL[id].x = keypoint.x
            newL[id].y = keypoint.y
            newL[id].visibility = keypoint.score
            landmarkConfig_tmp.push({'name':nameID})
        }
    })
    return {first:newL,second:landmarkConfig_tmp}
}

export const liveDrawMovenetLandamrks = (ctx,keypoints,areNormalized,width,height,original_width,original_height)=>{
    //
    let point = {}
    keypoints.forEach((keypoint)=>{
        ctx.beginPath()
        ctx.fillStyle = 'white'
        point.x = (areNormalized) ? keypoint.x * width: (keypoint.x / original_width) * width
        point.y = (areNormalized) ? keypoint.y * height: (keypoint.y / original_height) * height
        ctx.arc(point.x,point.y,2,0,2*Math.PI,true)
        ctx.stroke()
        ctx.fill()
    })
}

export const liveDrawMovenetLandmarksWebcam = (ctx,element,areNormalized,width,height,original_width,original_height,option,flag_clear)=>{
    let landmarks_map = []
    switch (option) {
        case 'global_motor_skills':
            landmarks_map = globallandmarks_include_map;
            break;
        case 'fine_motor_skills':
            landmarks_map = handlandmarks_include_map;
            break;
        case 'face_expression':
            landmarks_map = facelandmarks_include_map;
            break;
        default:
            landmarks_map = facelandmarks_include_map;
            break;
    }
    let point = {}
    let landmarkConfig_tmp = []
    if (!flag_clear){
        ctx.clearRect(0,0,width,height)
    }
    element.keypoints.forEach((keypoint,f_index)=>{
        if(landmarks_map[f_index]?.include) {
	    ctx.beginPath()
            ctx.fillStyle = 'white'
            point.x = (areNormalized) ? (-keypoint.x * width)+width: -(keypoint.x / original_width) * width +width
            point.y = (areNormalized) ? keypoint.y * height: (keypoint.y / original_height) * height
            ctx.arc(point.x,point.y,2,0,2*Math.PI,true)
            ctx.stroke()
            ctx.fill()
        }
    })
}

export const drawPoint = (ctx,keypoint,width,height) =>{

}

export const normalizePoint = (point) =>{
    point.x= point.x / 1000
    point.z= point.z  / 1000
    point.y= point.y / 1000
    return point
}

export const filterParasites = (csv_content,normalize_points)=>{

}

export const csv2json = (csv_content,normalize_points)=>{
    const csv_content_length = csv_content?.length
    const time = parseInt(csv_content[csv_content?.length-1]?.Time)
    const frequency = parseInt(time / csv_content_length)
    let landmarks = []
    for(let i = 0;i<csv_content_length;i++){
        let frame_array = []
        let pass_array=Object.values(csv_content[i])
        pass_array.shift()
        for(let j=0;j<pass_array.length;j+=3){
            let point = {}
            point.x= parseFloat(pass_array[j])
            point.z= parseFloat(pass_array[j+1])
            point.y= parseFloat(pass_array[j+2])
            point.visibility = 1.0
            frame_array.push(normalize_points ? normalizePoint(point) : point)
        }
        landmarks.push([frame_array])
    }
    let json_content = {
        frequency:frequency,
        landmarks: landmarks
    }
    return json_content
}

export const json2csv = (json_content,option)=>{
    
    let csv_content = []
    let header_line = []
    const frequency = parseInt(json_content.frequency)
    let time = 0 
    header_line.push('Time')
    let p_label
    
    let landmarks_map = []
    switch (option) {
        case 'global_motor_skills':
            landmarks_map = globallandmarks_include_map;
            break;
        case 'fine_motor_skills':
            landmarks_map = handlandmarks_include_map;
            break;
        case 'face_expression':
            landmarks_map = facelandmarks_include_map;
            break;
        case 'full_body':
            landmarks_map = facelandmarks_include_map;
            break;
        default:
            landmarks_map = facelandmarks_include_map;
            break;
    }
    json_content.landmarks.forEach((frame,f_index)=>{
        let landmarks_line = []
        landmarks_line.push(time) // push time of frame in milliseconds
        time+= frequency
        frame.forEach((person,p_index)=>{
            if(f_index === 0){
                p_label = '_Person'+p_index
                person.forEach((element,e_index)=>{
                    header_line.push('X_'+element.name+p_label)
                    header_line.push('Y_'+element.name+p_label)
                    header_line.push('Z_'+element.name+p_label)
                    //}
                })
                csv_content.push(header_line)
            }
            // Fill other lines
            person.sort(function(a, b){
                return a.id-b.id
            })
            person.forEach((keypoint,k_index)=>{
                landmarks_line.push(Number(keypoint.x).toFixed(6).replace('.', ','))
                if (keypoint.x=='NaN') {
                    landmarks_line.push(Number(NaN).toFixed(6).replace('.', ','))
                } else {
                    landmarks_line.push(Number(0).toFixed(6).replace('.', ','))
                }
                landmarks_line.push(Number(keypoint.y).toFixed(6).replace('.', ','))
            })
        })

        // At end of frame, push CSV line
        csv_content.push(landmarks_line)
    })
    return csv_content
}
